import React, { Component } from "react";
import { connect } from "react-redux";
import { FormGroup, FormControl, Dropdown } from "react-bootstrap";
import Moment from "react-moment";
import moment from "moment";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { showModal, hideModal } from "actions/modalActions";
import * as plansActions from "actions/plansActions";
import * as employeesActions from "actions/employeesActions";
import * as shiftsActions from "actions/shiftsActions";
import { plansService, employeesService } from "services";
import { shiftType } from "services/shiftsService";
import {
	FiMoreHorizontal,
	FiUpload,
	FiTool,
	FiRefreshCcw,
	FiX,
} from "react-icons/fi";
import Layout from "components/Layout";
import CalendarHeader from "components/Calendars/CalendarHeader";
import CalendarViewEdit from "components/Calendars/CalendarViewEditModal";
import PreferenceEdit from "components/Preferences/PreferenceEditModal";
import EmployeeSelectSearch from "components/EmployeeSelectSearch/EmployeeSelectSearch";
import Modal from "components/Modal";
import { chunkArray } from "utils/utils";
import Loading from "components/Loading";
import { isAdmin, isSupervisor } from "utils/utils";
import HelpBanner from "components/HelpBanner";
import { convertFromUTC } from "utils/datetime";
import { getContrastColor } from "utils/utils";
import { withTranslation } from "react-i18next";

const PDF_CAPTURE_SCALE = 2;
const PDF_MAX_MONTH_PIXELS = 4000000;
const PDF_JPEG_QUALITY = 0.85;
const PDF_PAGE_MARGIN_PT = 24;
const PDF_MONTH_GAP_PT = 16;
const PDF_HEADER_HEIGHT_PT = 28;

class Calendar extends Component {
	constructor(props) {
		super(props);

		const today = new Date();
		const year = today.getFullYear();
		this.closeModal = this.closeModal.bind(this);
		this.openEditCalendarViewModal = this.openEditCalendarViewModal.bind(this);
		this.openNewPreferenceModal = this.openNewPreferenceModal.bind(this);
		this.updateCalendarHeader = this.updateCalendarHeader.bind(this);
		this.employeeSelectFetchOptions = { enabled: true };

		this.state = {
			loading: false,
			year,
			search_employee: this.props.user.id,
			search_employee_name: this.props.user.name,
			calendarKnownEmployee: null,
			plan_assignments: [],
			updateIndicator: 0,
			worked_holidays: [],
			show_worked_holidays: false,
			dayPopover: null,
			exportingPdf: false,
		};
	}

	async componentDidMount() {
		const { user } = this.props;

		// Leer query parameter 'employee' de la URL
		const queryParams = new URLSearchParams(window.location.search);
		const employeeFromQuery = queryParams.get("employee");

		if (user.id === 6 || user.id === 3 || user.id === 1489) {
			this.props.getAttendanceShifts();
		}

		if (isAdmin() || isSupervisor()) {
			await Promise.all([
				this.props.getPlanViews(true),
				this.props.getDefaultShift(),
			]);

			// Si hay un empleado en el query y somos admin/supervisor, validarlo y aplicarlo
			if (employeeFromQuery) {
				const employeeId = parseInt(employeeFromQuery, 10);
				if (!Number.isNaN(employeeId)) {
					try {
						const res = await employeesService.getById(employeeId);
						if (res.ok && res.id) {
							this.setState({
								search_employee: res.id,
								search_employee_name: `${res.name} ${res.surname || ""}`.trim(),
								calendarKnownEmployee: res,
							});
						} else {
							console.warn("Empleado no encontrado o sin permisos:", employeeId);
						}
					} catch (e) {
						console.warn("Empleado no encontrado o sin permisos:", employeeId, e);
					}
				}
			}
		}

		// Cargar datos DESPUÉS de haber aplicado el query parameter
		await Promise.all([this.getData()]);
	}

	closeModal() {
		this.props.hideModal();
	}

	toggleWorkedHolidays() {
		this.setState((prevState) => ({
			show_worked_holidays: !prevState.show_worked_holidays,
		}));
	}

	openEditCalendarViewModal() {
		const { plan_views } = this.props;
		// console.log(plan_views);
		this.props.showModal(
			{
				open: true,
				title: this.props.t('calendars.configureView'),
				style: { width: "400px" },
				content: (
					<CalendarViewEdit
						handleClose={this.closeModal}
						updateCalendarHeader={this.updateCalendarHeader}
						plan_views={plan_views}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	openNewPreferenceModal() {
		this.props.showModal(
			{
				open: true,
				title: this.props.t('calendars.requestShiftPreference'),
				style: { width: "500px" },
				content: <PreferenceEdit handleClose={this.closeModal} />,
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	async getData() {
		this.setState({ loading: true }); // loading

		await Promise.all([
			this.props.getEmployeeAbsenceCalendar(
				this.state.search_employee,
				this.state.year
			), // carga ausencias del empleado
			this.getAssignmentsList(), // carga turnos del empleado
		]);

		const worked_holidays = this.props.employee_absence_calendar.filter((o) => {
			return o.worked_holiday === true;
		});

		this.setState({
			loading: false,
			worked_holidays,
		});
	}

	// retrieve assignments list by employee and month
	async getAssignmentsList() {
		const employee_id = this.state.search_employee;
		// console.log(this.state.year);
		const start_from = moment(this.state.year + "-01-01")
			.startOf("year")
			.format("YYYY-MM-DD");
		const start_to = moment(this.state.year + "-01-01")
			.endOf("year")
			.format("YYYY-MM-DD");

		const response = await plansService.getPlanAssignments({
			employee_id,
			start: start_from,
			end: start_to,
		});

		// console.log(response);
		const plan_assignments = response.data;

		this.setState({
			plan_assignments:
				!plan_assignments ||
				plan_assignments.length < 1 ||
				plan_assignments[0].plans.length < 1
					? []
					: plan_assignments[0].plans,
		});
	}

	handleChangeSearch = (event) => {
		const target_id = event.target.id;
		var search_employee_name = this.state.search_employee_name;

		if (target_id === "search_employee") {
			search_employee_name =
				event.target.options[event.target.selectedIndex].text;
		}
		this.setState(
			{
				[target_id]: event.target.value,
				search_employee_name,
			},
			async () => {
				this.getData();
			}
		);
	};

	handleCalendarEmployeeChange = (idStr, emp) => {
		if (!idStr) return;
		const id = Number(idStr);
		const name = emp
			? `${emp.name} ${emp.surname || ""}`.trim()
			: this.state.search_employee_name;
		this.setState(
			{
				search_employee: id,
				search_employee_name: name,
				calendarKnownEmployee: emp || null,
			},
			async () => {
				this.getData();
			}
		);
	};

	async handleExportCalendarPDF() {
		if (this.state.exportingPdf) return;

		this.setState({ exportingPdf: true });
		try {
			await this.generateCalendarPDF();
		} catch (error) {
			console.error("Error exporting calendar PDF", error);
		} finally {
			this.setState({ exportingPdf: false });
		}
	}

	async generateCalendarPDF() {
		const el = document.getElementById("miCalendario");
		if (!el) return;

		const twoFrames = () =>
			new Promise((r) => requestAnimationFrame(() => requestAnimationFrame(r)));
		await twoFrames();
		await new Promise((r) => setTimeout(r, 250));

		const monthElements = Array.from(
			el.querySelectorAll(".list-calendar .month")
		);
		if (monthElements.length === 0) return;

		const monthImages = [];
		try {
			for (let index = 0; index < monthElements.length; index += 1) {
				const month = monthElements[index];
				const marker = `calendar-export-month-${index}`;
				const width = Math.ceil(month.scrollWidth);
				const height = Math.ceil(month.scrollHeight);
				const captureScale = Math.min(
					PDF_CAPTURE_SCALE,
					Math.sqrt(PDF_MAX_MONTH_PIXELS / (width * height))
				);

				month.setAttribute("data-calendar-export", marker);
				const canvas = await html2canvas(month, {
					scale: captureScale,
					useCORS: true,
					backgroundColor: "#ffffff",
					width,
					height,
					scrollX: 0,
					scrollY: 0,
					onclone: (doc) => {
						const exportOverlay = doc.querySelector(
							".calendar-export-overlay"
						);
						if (exportOverlay) exportOverlay.style.display = "none";

						const root = doc.querySelector(
							`[data-calendar-export="${marker}"]`
						);
						if (!root) return;
						root.style.boxShadow = "none";
						root.querySelectorAll("*").forEach((node) => {
							node.style.animation = "none";
							node.style.transition = "none";
						});
					},
				});

				monthImages.push({
					data: canvas.toDataURL("image/jpeg", PDF_JPEG_QUALITY),
					width: canvas.width,
					height: canvas.height,
				});
				canvas.width = 1;
				canvas.height = 1;
			}
		} finally {
			monthElements.forEach((month) =>
				month.removeAttribute("data-calendar-export")
			);
		}

		const pdf = new jsPDF({
			orientation: "landscape",
			unit: "pt",
			format: "a4",
			compress: true,
		});
		const pageWidth = pdf.internal.pageSize.getWidth();
		const pageHeight = pdf.internal.pageSize.getHeight();
		const contentTop = PDF_PAGE_MARGIN_PT + PDF_HEADER_HEIGHT_PT;
		const availableHeight = pageHeight - contentTop - PDF_PAGE_MARGIN_PT;
		const slotWidth =
			(pageWidth - PDF_PAGE_MARGIN_PT * 2 - PDF_MONTH_GAP_PT) / 2;
		const calendarPageCount = Math.ceil(monthImages.length / 2);
		const calendarTitle =
			el.querySelector(".heading .title")?.textContent?.trim() ||
			this.props.t("calendars.myCalendar");
		const cleanText = (node) =>
			node?.textContent?.replace(/\s+/g, " ").trim() || "";
		const kpis = Array.from(
			el.querySelectorAll(".header-widgets .widget-content")
		).map((widget) => ({
			label: cleanText(widget.querySelector(".widget-title")),
			value: cleanText(widget.querySelector(".widget-counter")),
		}));
		const detailsTable = el.querySelector(".calendar-caption .table-hours");
		const detailsHead = detailsTable
			? [
					Array.from(detailsTable.querySelectorAll("thead th")).map(
						cleanText
					),
			  ]
			: [];
		const detailsBody = detailsTable
			? Array.from(detailsTable.querySelectorAll("tbody tr")).map((row) =>
					Array.from(row.querySelectorAll("td")).map(cleanText)
			  )
			: [];
		const drawPdfTitle = (subtitle) => {
			pdf.setFont("helvetica", "bold");
			pdf.setFontSize(14);
			pdf.setTextColor(35, 35, 35);
			pdf.text(
				`${calendarTitle} - ${this.state.year}`,
				PDF_PAGE_MARGIN_PT,
				PDF_PAGE_MARGIN_PT + 14
			);
			if (subtitle) {
				pdf.setFontSize(11);
				pdf.text(subtitle, PDF_PAGE_MARGIN_PT, PDF_PAGE_MARGIN_PT + 36);
			}
		};

		// La primera página se genera con texto y tablas vectoriales para que el
		// resumen sea nítido y apenas incremente el peso del PDF.
		drawPdfTitle(this.props.t("calendars.exportSummary"));
		let summaryCursorY = PDF_PAGE_MARGIN_PT + 52;
		if (kpis.length > 0) {
			const columnCount = Math.min(4, kpis.length);
			const boxGap = 10;
			const boxHeight = 54;
			const boxWidth =
				(pageWidth -
					PDF_PAGE_MARGIN_PT * 2 -
					boxGap * (columnCount - 1)) /
				columnCount;

			kpis.forEach((kpi, index) => {
				const column = index % columnCount;
				const row = Math.floor(index / columnCount);
				const x = PDF_PAGE_MARGIN_PT + column * (boxWidth + boxGap);
				const y = summaryCursorY + row * (boxHeight + boxGap);

				pdf.setDrawColor(220, 222, 226);
				pdf.setFillColor(247, 248, 250);
				pdf.roundedRect(x, y, boxWidth, boxHeight, 3, 3, "FD");
				pdf.setFont("helvetica", "normal");
				pdf.setFontSize(8);
				pdf.setTextColor(90, 90, 90);
				pdf.text(
					pdf.splitTextToSize(kpi.label, boxWidth - 16),
					x + 8,
					y + 14
				);
				pdf.setFont("helvetica", "bold");
				pdf.setFontSize(16);
				pdf.setTextColor(35, 35, 35);
				pdf.text(kpi.value || "-", x + 8, y + 43);
			});

			summaryCursorY +=
				Math.ceil(kpis.length / columnCount) * (boxHeight + boxGap) + 8;
		}

		if (detailsHead.length > 0 && detailsBody.length > 0) {
			pdf.setFont("helvetica", "bold");
			pdf.setFontSize(11);
			pdf.setTextColor(35, 35, 35);
			pdf.text(
				this.props.t("calendars.exportDetails"),
				PDF_PAGE_MARGIN_PT,
				summaryCursorY + 12
			);

			autoTable(pdf, {
				startY: summaryCursorY + 20,
				head: detailsHead,
				body: detailsBody,
				theme: "grid",
				styles: { fontSize: 9, cellPadding: 4 },
				headStyles: { fillColor: [70, 70, 70] },
				margin: {
					top: PDF_PAGE_MARGIN_PT + PDF_HEADER_HEIGHT_PT,
					right: PDF_PAGE_MARGIN_PT,
					bottom: PDF_PAGE_MARGIN_PT,
					left: PDF_PAGE_MARGIN_PT,
				},
				didDrawPage: (data) => {
					if (data.pageNumber > 1) {
						drawPdfTitle(this.props.t("calendars.exportDetails"));
					}
				},
			});
		}

		for (let pageIndex = 0; pageIndex < calendarPageCount; pageIndex += 1) {
			pdf.addPage("a4", "landscape");
			drawPdfTitle();

			monthImages
				.slice(pageIndex * 2, pageIndex * 2 + 2)
				.forEach((image, slotIndex) => {
					const scale = Math.min(
						slotWidth / image.width,
						availableHeight / image.height
					);
					const imageWidth = image.width * scale;
					const imageHeight = image.height * scale;
					const slotX =
						PDF_PAGE_MARGIN_PT +
						slotIndex * (slotWidth + PDF_MONTH_GAP_PT);
					const imageX = slotX + (slotWidth - imageWidth) / 2;

					pdf.addImage(
						image.data,
						"JPEG",
						imageX,
						contentTop,
						imageWidth,
						imageHeight,
						undefined,
						"FAST"
					);
				});
		}

		const totalPages = pdf.getNumberOfPages();
		for (let pageNumber = 1; pageNumber <= totalPages; pageNumber += 1) {
			pdf.setPage(pageNumber);
			pdf.setFont("helvetica", "normal");
			pdf.setFontSize(9);
			pdf.setTextColor(100, 100, 100);
			pdf.text(
				`${pageNumber} / ${totalPages}`,
				pageWidth - PDF_PAGE_MARGIN_PT,
				pageHeight - 10,
				{ align: "right" }
			);
		}

		pdf.save(`calendario-${this.state.year}.pdf`);
	}

	getMonths = () =>
		Array.from({ length: 12 }, (item, i) => {
			const fullCalendar = this.props.employee_absence_calendar;

			const monthCalendar = fullCalendar.filter((o) => {
				let [year, month, date] = o.day.split("-");

				return month * 1 === i + 1 ? true : false;
			});

			// console.log(monthCalendar);

			// si el primer dia del mes no es lunes, se añaden días vacíos de relleno
			const weekDay = monthCalendar[0].weekday;
			if (weekDay !== 1) {
				for (let i = weekDay; i > 1; i--) {
					monthCalendar.unshift({ day: null });
				}
			}

			// separa mes en semanas
			const monthCalendarWithWeeks = chunkArray(monthCalendar, 7);

			return (
				<div className="column col-sm-12 col-md-12 col-xl-6" key={i}>
					<article className="card month">
						<h3>{new Date(0, i).toLocaleString(this.props.i18n.language, { month: "long" })}</h3>

						<table className="table-calendar table-calendar-full">
							<thead>
								<tr>{this.getWeekDays()}</tr>
							</thead>
							<tbody>{this.getWeeks(monthCalendarWithWeeks)}</tbody>
						</table>
					</article>
				</div>
			);
		});

	// starts with a monday
	getWeekDays = () =>
		Array.from({ length: 7 }, (item, i) => (
			<th key={i}>
				{new Date(2021, 10, i + 1).toLocaleString(this.props.i18n.language, {
					weekday: "short",
				})}
			</th>
		));

	getWeeks = (monthCalendarWithWeeks) =>
		monthCalendarWithWeeks.map((week, i) => {
			return <tr key={i}>{this.getCalendarDays(week)}</tr>;
		});

	getPlanForDay = (day) =>
		this.state.plan_assignments.find((o) => {
			return o.day === day;
		});

	getShiftIntervals = (time_intervals, color, condensed = false) => {
		if (!time_intervals || time_intervals.length === 0) return null;
		const work = time_intervals.filter((t) => t.time_type?.work_time);
		if (work.length === 0) return null;

		if (condensed) {
			// primer inicio y último fin del día
			const firstStart = work.reduce(
				(min, t) => (t.start < min ? t.start : min),
				work[0].start
			);
			const lastEnd = work.reduce(
				(max, t) => (t.end > max ? t.end : max),
				work[0].end
			);
			const startStr = convertFromUTC(firstStart).replace(":00", "");
			const endStr = convertFromUTC(lastEnd).replace(":00", "");
			return (
				<li
					className="time-interval"
					style={{ color: color && getContrastColor(color) }}
				>
					{startStr}-{endStr}h
				</li>
			);
		}

		return work.map((item, i) => {
			const start = convertFromUTC(item.start).replace(":00", "");
			const end = convertFromUTC(item.end).replace(":00", "");
			return (
				<li
					key={i}
					style={{
						color: color && getContrastColor(color),
						backgroundColor: color && getContrastColor(getContrastColor(color)),
					}}
					className="time-interval"
				>
					{start}-{end}h
				</li>
			);
		});
	};

	getShiftListTdContent = (
		day_assignments,
		forceDetails = false,
		condensedIntervals = false
	) =>
		day_assignments.map((item, i) => {
			const shift = item.shift;
			const color = shift.background_color;
			const className = "shift-item" + " " + "items_" + day_assignments.length;
			const time_intervals = item.time_intervals_from_manual
				? item.time_intervals
				: shift.time_intervals;
			const is_curro = shift.type == shiftType.work;

			const funcion = item.function;
			const showFunctions =
				funcion && is_curro && (forceDetails || day_assignments.length === 1);
			const ubications = item.ubications;
			const showUbications =
				ubications &&
				is_curro &&
				(forceDetails || day_assignments.length === 1);

			return (
				<li
					className={className}
					key={i}
					style={{ backgroundColor: color && color }}
				>
					<span
						className="shift-name"
						style={{ color: color && getContrastColor(color) }}
					>
						{shift.name}
					</span>
					{forceDetails && shift.description && (
						<span
							className="shift-description"
							style={{ color: color && getContrastColor(color) }}
						>
							{shift.description}
						</span>
					)}
					{time_intervals && time_intervals.length > 0 && (
						<ul className="time-intervals">
							{this.getShiftIntervals(
								time_intervals,
								color,
								condensedIntervals
							)}
						</ul>
					)}

					{showFunctions && (
						<span
							title={funcion.name}
							className="shift-function"
							style={{
								backgroundColor: funcion.background_color
									? funcion.background_color
									: getContrastColor(shift.background_color),
								borderColor: funcion.border_color && funcion.border_color,
								color: funcion.background_color
									? getContrastColor(funcion.background_color)
									: getContrastColor(getContrastColor(shift.background_color)),
							}}
						>
							{funcion.name}
						</span>
					)}

					{showUbications && (
						<ul className="ubication-list">
							{(forceDetails ? ubications : ubications.slice(0, 1)).map(
								(ubication, i) => (
									<li
										key={i}
										title={`${ubication.name} ${ubication.description ? "-" + ubication.description : ""}`}
										className="ubication-item shift-ubication"
										style={{
											backgroundColor: ubication.background_color
												? ubication.background_color
												: getContrastColor(shift.background_color),
											borderColor: ubication.border_color || undefined,
											color: ubication.background_color
												? getContrastColor(ubication.background_color)
												: getContrastColor(
														getContrastColor(shift.background_color)
													),
										}}
									>
										{ubication.name}
									</li>
								)
							)}

							{!forceDetails && ubications?.length > 1 && (
								<li className="ubication-item more-ubications">
									<span>+{ubications.length - 1}</span>
								</li>
							)}
						</ul>
					)}
				</li>
			);
		});

	/* Inicio popover día calendario */
	openDayDetailPopover = (o, plan, evt) => {
		const container = document.getElementById("miCalendario");
		if (!container) return;

		const rect = evt.currentTarget.getBoundingClientRect();
		const pad = 12;
		const cRect = container.getBoundingClientRect();
		const top = rect.bottom - cRect.top + container.scrollTop + 8;
		const anchorX =
			rect.left - cRect.left + rect.width / 2 + container.scrollLeft;
		const popoverWidth = Math.min(230, container.clientWidth - 2 * pad);
		const halfW = popoverWidth / 2;
		const clampedCenter = Math.max(
			halfW + pad,
			Math.min(container.clientWidth - halfW - pad, anchorX)
		);

		this.setState({ dayPopover: { o, plan, top, left: clampedCenter, anchorX } }, () => {
			document.addEventListener("keydown", this._onEscClose);
			document.addEventListener("click", this._onDocClick, true);
		});
	};

	closeDayDetailPopover = () => {
		this.setState({ dayPopover: null }, () => {
			document.removeEventListener("keydown", this._onEscClose);
			document.removeEventListener("click", this._onDocClick, true);
		});
	};

	_onEscClose = (e) => {
		if (e.key === "Escape") this.closeDayDetailPopover();
	};

	_onDocClick = (e) => {
		// si el clic es dentro del popover, no cerrar
		if (e.target.closest && e.target.closest(".day-popover")) return;
		this.closeDayDetailPopover();
	};

	// contenido del popover
	renderDayPopover = () => {
		const dp = this.state.dayPopover;
		if (!dp) return null;

		const { o, plan, top, left, anchorX } = dp;
		const assignments = plan?.assignments || [];
		const isHoliday = !!o.day_type?.holiday;
		const isWorked = !!o.worked_holiday;
		const holidayColor = o.day_type?.color || null;
		const holidayText = o.day_type?.name || "";
		const holidayDesc = o.comments || o.day_type?.description;

		const tituloRaw = new Date(o.day + "T00:00:00").toLocaleDateString(
			this.props.i18n.language,
			{
				weekday: "long",
				day: "numeric",
			}
		);
		const titulo = tituloRaw.charAt(0).toUpperCase() + tituloRaw.slice(1);

		return (
			<div
				className="day-popover"
				style={{ top: `${top}px`, left: `${left}px`, transform: "translateX(-50%)" }}
				role="dialog"
				aria-modal="false"
			>
				<div
					className="day-popover-arrow"
					style={{ left: `calc(50% + ${anchorX - left}px)` }}
				/>
				<div className="day-popover-header">
					<h4 className="day-popover-title">{titulo}</h4>
					<button
						type="button"
						className="day-popover-close"
						onClick={this.closeDayDetailPopover}
						aria-label={this.props.t('common.close')}
					>
						<FiX />
					</button>
				</div>

				{/* Info festivo */}
				{(isHoliday || isWorked) && (
					<div className="holiday-block">
						<div
							className="holiday-chip"
							style={{
								backgroundColor: holidayColor || undefined,
								color: holidayColor
									? getContrastColor(holidayColor)
									: undefined,
							}}
						>
							<div className="holiday-chip-title">
								{isWorked ? this.props.t('calendars.workedHoliday') : ""}
							</div>
							{holidayText && (
								<div className="holiday-chip-name">{holidayText}</div>
							)}
							{holidayDesc && (
								<div className="holiday-chip-desc">{holidayDesc}</div>
							)}
						</div>
					</div>
				)}

				{assignments.length > 0 ? (
					<ul className="shift-list-items">
						{this.getShiftListTdContent(assignments, true)}
					</ul>
				) : (
					// si no hay turnos y no es festivo, mostramos "sin turnos"
					!isHoliday &&
					!isWorked && <p className="no-results mb0">{this.props.t('calendars.noShiftsAssigned')}</p>
				)}
			</div>
		);
	};

	// la madre del cordero
	getCalendarDays = (week) =>
		week.map((o, i) => {
			if (o.day === null) return <td key={i}></td>;

			let [year, month, date] = o.day.split("-");
			const plan = this.getPlanForDay(o.day);
			const hasAssignments = !!(
				plan &&
				plan.assignments &&
				plan.assignments.length > 0
			);
			const isHoliday = !!o.day_type?.holiday;
			const isWorked = !!o.worked_holiday;

			const holidayColor = o.day_type?.color || null;
			const holidayTitle =
				isHoliday || isWorked
					? [
							isWorked ? this.props.t('calendars.workedHoliday') : null,
							o.day_type?.name || null,
							o.comments || null,
						]
							.filter(Boolean)
							.join(" — ")
					: null;
			// console.log(week);
			// console.log(plan);

			if (o.absence || isHoliday || hasAssignments) {
				var shiftList;
				var className = "td-container";
				var moreTag = null;

				if (hasAssignments) {
					const shift = plan.assignments[0].shift;

					if (
						plan.assignments.length === 1 &&
						plan.assignments[0].shift.id === this.props.default_shift?.id
					) {
						//className += " default-shift"
						return (
							<td key={i}>
								<span className="cal-date">{date}</span>
							</td>
						);
					} else {
						className += " has-shifts";
						const visibleAssignments = plan.assignments.slice(0, 2);
						const extraCount = plan.assignments.length - 2;

						shiftList = (
							<ul className="shift-list-items">
								{this.getShiftListTdContent(visibleAssignments, false, true)}
							</ul>
						);
						if (extraCount > 0) {
							moreTag = (
								<span className="more-assignments">+{extraCount} {this.props.t('calendars.more')}</span>
							);
						}
					}
				}

				if (o.absence) {
					className += " absence";
				}

				if (isHoliday) {
					className += " holiday";
				}

				if (isWorked) {
					className += " worked-holiday";
				}
				// Solo clicable si hay turnos
				const clickProps =
					hasAssignments || isHoliday || isWorked
						? {
								role: "button",
								tabIndex: 0,
								onClick: (e) => this.openDayDetailPopover(o, plan, e),
								onKeyDown: (e) =>
									e.key === "Enter"
										? this.openDayDetailPopover(o, plan, e)
										: null,
							}
						: {};

				return (
					<td key={i}>
						<div className={className} {...clickProps}>
							{/* tinte de color para festivo */}
							{(isHoliday || isWorked) && holidayColor && (
								<span
									className="holiday-tint"
									style={{ backgroundColor: holidayColor }}
								/>
							)}
							<span className="cal-date">{date}</span>
							{shiftList}
							{moreTag}
						</div>
					</td>
				);
			}

			return (
				<td key={i}>
					<span className="cal-date">{date}</span>
				</td>
			);
		});

	getContent = () => {
		if (this.state.loading) {
			return <Loading />;
		} else if (this.props.employee_absence_calendar.length === 0) {
			return <p className="no-results">{this.props.t('calendars.errorLoadingCalendar')}</p>;
		}

		return <div className="row list-calendar">{this.getMonths()}</div>;
	};

	updateCalendarHeader = () => {
		this.setState((prevState) => ({
			updateIndicator: prevState.updateIndicator + 1, // Incrementa el indicador para forzar la actualización
		}));
	};

	render() {
		const { worked_holidays, show_worked_holidays, exportingPdf } = this.state;

		// console.log(worked_holidays);
		const currentYear = new Date().getFullYear();
		const range = (start, stop, step) =>
			Array.from(
				{ length: (stop - start) / step + 1 },
				(_, i) => start + i * step
			);
		const optionYearList = range(currentYear + 1, 2020, -1).map((item, i) => {
			return (
				<option key={i} value={item}>
					{item}
				</option>
			);
		}, this);

		var title_mi_calendario = this.props.user.id !== this.state.search_employee * 1
			? this.props.t('calendars.calendarOf', { name: this.state.search_employee_name })
			: this.props.t('calendars.myCalendar');

		return (
			<>
				<Layout className="page-calendar" context="calendar">
					<div id="miCalendario" className="pb5 mi-calendario">
						<div className="heading">
							<h1 className="title">{title_mi_calendario}</h1>
							<div style={{ marginRight: "8px" }}>
								<HelpBanner
									title={this.props.t('common.needHelp')}
									text={this.props.t('common.helpText')}
									linkText={this.props.t('common.moreInfo')}
									linkHref="https://help.plain.ninja/es/articles/11149660-que-es-el-apartado-mi-calendario-en-plain"
								/>
							</div>
							<div className="heading-filters"></div>
							<div className="heading-actions">
								<button
									type="button"
									className="btn btn-primary mr10"
									onClick={this.openNewPreferenceModal}
								>
									<FiRefreshCcw className="mr5" />
									{this.props.t('calendars.requestShiftPreference')}
								</button>
								<FormGroup
									className="form-group form-select-user mr10"
									controlId="search_employee"
								>
									<EmployeeSelectSearch
										className={
											(isAdmin() || isSupervisor())
												? "form-select-user"
												: "hidden"
										}
										controlId="search_employee"
										multiple={false}
										allowClear={false}
										value={String(this.state.search_employee)}
										onChange={this.handleCalendarEmployeeChange}
										fetchOptions={this.employeeSelectFetchOptions}
										placeholder={this.props.t('common.searchEmployee')}
										knownEmployee={
											this.state.calendarKnownEmployee ||
											(Number(this.state.search_employee) ===
											Number(this.props.user.id)
												? this.props.user
												: null)
										}
										pinnedShortcut={
											Number(this.state.search_employee) !==
											Number(this.props.user.id)
												? {
														id: this.props.user.id,
														label: this.props.t('calendars.myCalendar'),
														employee: this.props.user,
												  }
												: null
										}
									/>
								</FormGroup>

								<FormGroup className="form-group" controlId="year">
									<FormControl
										type="text"
										value={this.state.year}
										onChange={this.handleChangeSearch}
										as="select"
									>
										{optionYearList}
									</FormControl>
								</FormGroup>

								<Dropdown>
									<Dropdown.Toggle variant="action" disabled={exportingPdf}>
										<FiMoreHorizontal />
									</Dropdown.Toggle>
									<Dropdown.Menu>
										<Dropdown.Item
											as="button"
											disabled={exportingPdf}
											onClick={() => this.handleExportCalendarPDF()}
										>
											<FiUpload className="dropdown-icon" /> {this.props.t('calendars.exportToPDF')}
										</Dropdown.Item>

										{(isAdmin() || isSupervisor()) &&
											this.props.plan_views.length > 1 && (
												<Dropdown.Item
													as="button"
													onClick={() => this.openEditCalendarViewModal()}
												>
													<FiTool className="dropdown-icon" /> {this.props.t('calendars.configureView')}
												</Dropdown.Item>
											)}
									</Dropdown.Menu>
								</Dropdown>
							</div>
						</div>

						<CalendarHeader
							employee_id={this.state.search_employee}
							year={this.state.year}
							plan_views={this.props.plan_views}
							updateIndicator={this.state.updateIndicator}
						/>

						{this.getContent()}

						<div className="box box-total">
							<div className="box-total-header">
								<h4>
									{this.props.t('calendars.totalWorkedHolidays')}{" "}
									<strong>{worked_holidays.length}</strong>
								</h4>
								<button
									type="button"
									className="button-link"
									onClick={() => this.toggleWorkedHolidays()}
								>
									{show_worked_holidays ? this.props.t('calendars.hideDetail') : this.props.t('calendars.showDetail')}
								</button>
							</div>

							{show_worked_holidays && (
								<ul className="list-worked-holidays">
									{worked_holidays.map((item, i) => {
										return (
											<li key={i}>
												<span
													className="tag-day-type"
													style={{
														backgroundColor:
															item.day_type.color && item.day_type.color,
													}}
												>
													{item.day_type.name}
												</span>
												<Moment format="DD/MM/YY">{item.day}</Moment>
												<span>{item.comments}</span>
											</li>
										);
									})}
								</ul>
							)}
						</div>

						{this.renderDayPopover()}
					</div>
				</Layout>

				{exportingPdf && (
					<div
						className="calendar-export-overlay"
						role="status"
						aria-live="polite"
					>
						<div className="calendar-export-overlay-card">
							<span
								className="spinner-border"
								aria-hidden="true"
							/>
							<strong>{this.props.t("calendars.exportingPDF")}</strong>
							<span>{this.props.t("calendars.exportingPDFHint")}</span>
						</div>
					</div>
				)}

				<Modal hideModal={this.props.hideModal} />
			</>
		);
	}
}

const mapStateToProps = (reducers) => {
	return {
		...reducers.shiftsReducer,
		...reducers.workflowsReducer,
		...reducers.employeesReducer,
		...reducers.shiftsReducer,
		...reducers.plansReducer,
		user: reducers.authReducer.user,
		loading: reducers.workflowsReducer.loading,
	};
};

const mapDispatchToProps = (dispatch) => ({
	hideModal: () => dispatch(hideModal()),
	showModal: (modalProps, modalType) => {
		dispatch(showModal({ modalProps, modalType }));
	},
	getEmployeeAbsenceCalendar: (employee_id, year) =>
		dispatch(employeesActions.getEmployeeAbsenceCalendar(employee_id, year)),
	getSelectableDayTypes: () =>
		dispatch(calendarsActions.getSelectableDayTypes()),
	getWeekdaysDefault: () => dispatch(calendarsActions.getWeekdaysDefault()),
	getDefaultShift: () => dispatch(shiftsActions.getDefaultShift()),
	getPlanViews: (includeAll) => dispatch(plansActions.getPlanViews(includeAll)),
	getAttendanceShifts: () => dispatch(shiftsActions.getAttendanceShifts()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Calendar));
